import React from "react";
import queryString from "query-string";

import { ResetPasswordForm } from "../Forms/Auth";
import AuthContainer from "../../modules/auth/containers/Auth";
import withUnAuth from "./withUnAuth";

const ResetPasswordPage = ({ history, location: { search } }) => {
  const query = queryString.parse(search);
  return (
    <div className="ResetPasswordPage">
      <ResetPasswordForm history={history} token={query.token} />
    </div>
  );
};

export default withUnAuth(AuthContainer(ResetPasswordPage));
